/**
 * @desc 激活
 */
import { ApplyAuditForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ActivateAuctionApplyParameter = ApplyAuditForm

const method = 'PUT'
const url = '/trade/operation/apply/auction/activate'

export const activateAuctionApplyApi = (
  data?: ActivateAuctionApplyParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

activateAuctionApplyApi.method = method
activateAuctionApplyApi.url = url
